import React from 'react'
import { useQuery, useMutation } from '@apollo/client'
import { Redirect } from 'react-router-dom'
import Layout from '../../Layout'
import Loading from '../../Loading'
import Error from '../../Error'
import EditHeader from '../../Edit/Header'
import Form from '../Form'
import query from './lib/query'
import mutation from './lib/mutation'
import initialValues from './lib/initialValues'

export default ({
  match: {
    params: { id },
  },
}) => {
  const [mutate, mutationProps] = useMutation(mutation)

  const { loading, error, data } = useQuery(query, {
    variables: {
      id,
    },
  })

  if (loading) return <Loading />
  if (error) return <Error />

  return (
    <Layout>
      <EditHeader>Edit manufacturer</EditHeader>

      <Form
        initialValues={initialValues(data.manufacturer)}
        onSubmit={(data) => mutate({ variables: { id, data } })}
      />

      {mutationProps.error && <Error leftAligned />}
      {mutationProps.data && <Redirect to='/manufacturers' />}
    </Layout>
  )
}
